import { apiClient } from './api';

// Versicherung Interface basierend auf Backend-API
export interface Versicherung {
  id?: number;
  zulassungsantragId: number;
  versicherungsunternehmen?: string;
  versicherungsscheinNummer?: string;
  evbNummer: string;
  gueltigAb?: string;
  gueltigBis?: string;
  erstelltAm?: string;
}

// Request für Erstellung/Update
export interface VersicherungRequest {
  zulassungsantragId: number;
  versicherungsunternehmen?: string;
  versicherungsscheinNummer?: string;
  evbNummer: string;
  gueltigAb?: string;
  gueltigBis?: string;
}

const BASE_URL = '/versicherungen';

export const VersicherungService = {
  /**
   * Alle Versicherungen abrufen
   */
  async getAlleVersicherungen(): Promise<Versicherung[]> {
    const response = await apiClient.get<Versicherung[]>(BASE_URL);
    return response.data;
  },

  /**
   * Versicherung nach ID abrufen
   */
  async getVersicherungById(id: number): Promise<Versicherung> {
    const response = await apiClient.get<Versicherung>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Versicherung für einen Zulassungsantrag abrufen
   * API gibt 200 OK mit null zurück wenn keine Versicherung existiert
   */
  async getVersicherungByZulassungsantragId(zulassungsantragId: number): Promise<Versicherung | null> {
    const response = await apiClient.get<Versicherung | null>(`${BASE_URL}/zulassungsantrag/${zulassungsantragId}`);
    return response.data;
  },

  /**
   * Neue Versicherung erstellen
   */
  async createVersicherung(data: VersicherungRequest): Promise<Versicherung> {
    const response = await apiClient.post<Versicherung>(BASE_URL, data);
    return response.data;
  },

  /**
   * Versicherung aktualisieren
   */
  async updateVersicherung(id: number, data: VersicherungRequest): Promise<Versicherung> {
    const response = await apiClient.put<Versicherung>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  /**
   * Versicherung löschen
   */
  async deleteVersicherung(id: number): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${id}`);
  }
};
